import { render, staticRenderFns } from "./addAdmin.vue?vue&type=template&id=52c7a589&scoped=true&"
import script from "./addAdmin.vue?vue&type=script&lang=js&"
export * from "./addAdmin.vue?vue&type=script&lang=js&"
import style0 from "./addAdmin.vue?vue&type=style&index=0&id=52c7a589&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c7a589",
  null
  
)

export default component.exports